import React, { useState, useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { profile, logout } from "../../../../assets/index.js";
import "./Header.css";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logoutUser } from "../../../redux/slice/authSlice/UserSlice.js";

const Header = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const savedDarkMode = localStorage.getItem("darkMode");
    if (savedDarkMode === "true") {
      setIsDarkMode(true);
      document.body.classList.add("dark-mode");
    }
  }, []);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    document.body.classList.toggle("dark-mode", !isDarkMode);

    localStorage.setItem("darkMode", !isDarkMode);
  };

  const handleLogout = async () => {
    const token = localStorage.getItem("userToken");
    if (token) {
      await dispatch(logoutUser());
      navigate("/login");
    } else {
      navigate("/login");
    }
  };

  return (
    <Navbar
      bg="light"
      variant="dark"
      expand="lg"
      className="background-dark bg-gradient"
    >
      <div className="container-fluid d-flex justify-content-between">
        <Link to="/dashboard" className="text-decoration-none">
          <h5 className="text-dark ms-4 mt-2 landing-text-white">Dashboard</h5>
        </Link>
        <Nav className="d-flex">
          <Nav.Link onClick={toggleDarkMode}>
            <span
              className={`ms-3 me-2 p-2 rounded-3 button-all ${
                isDarkMode ? "text-white" : "text-dark"
              }`}
            >
              {isDarkMode ? "Light " : "Dark "}
            </span>
          </Nav.Link>
          <Nav.Link as={Link} to="/profile">
            <img src={profile} alt="Profile" className="img-width" />
          </Nav.Link>

          <Nav.Link>
            <img
              src={logout}
              onClick={handleLogout}
              alt="Logout"
              className="img-width"
            />
          </Nav.Link>
        </Nav>
      </div>
    </Navbar>
  );
};

export default Header;
